import React, { Component } from "react";

export default class Loader extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        return <div className="loader">{this.props.loadingText}</div>;
    }
}
